/**
 * Per-browser marker for which shared config is currently loaded.
 *
 * Purely local bookkeeping for the Config Manager UI — lets it show which
 * shared config (if any) matches what's currently on the dashboard. Namespaced
 * by userId to mirror the dashboard config key (`cintelion.dashboardConfig`).
 */

const BASE_KEY = 'cintelion.activeSharedConfigId';
const storageKey = (userId) => (userId ? `${BASE_KEY}.${userId}` : BASE_KEY);

export const getStoredActiveSharedConfigId = (userId) => {
  try {
    return localStorage.getItem(storageKey(userId));
  } catch {
    return null;
  }
};

export const setStoredActiveSharedConfigId = (userId, id) => {
  try {
    if (id) {
      localStorage.setItem(storageKey(userId), id);
    } else {
      localStorage.removeItem(storageKey(userId));
    }
  } catch {
    // localStorage unavailable — marker just won't survive a reload
  }
};
